/**
 * ============================================================================
 * @fileoverview
 * Zod 校验 Schema - 订阅周期 (Subscription Cycle)
 *
 * @description
 * 本文件为与 `subscription-cycle` 功能相关的 API 请求数据提供 Zod 校验 schema。
 * ============================================================================
 */
import { z } from 'zod';
/**
 * @description `GET /api/subscription/cycles/:cycleId/expired` 请求的校验 schema
 *              用于验证 URL params 和 query parameter。
 */
export const checkCycleExpiredRequestSchema = z.object({
    params: z.object({
        cycleId: z.string().uuid('Invalid cycleId format. Must be a UUID.'), // 假设 cycleId 是 UUID
    }),
    query: z.object({
        referenceDate: z
            .string()
            .datetime({ message: 'Invalid referenceDate format. Expected ISO date string.' })
            .optional(),
    }),
});
/**
 * @description `GET /api/subscription/cycles/user/:userId/current` 请求的校验 schema
 *              用于验证 URL params。
 *              注意：userId 通常由认证中间件提供，但如果路由设计允许直接通过URL参数传递，
 *              则也需要验证。这里我们假设它来自 req.user，所以这个schema可能只用于
 *              验证路径参数的格式，而不是实际的用户身份。
 */
export const getCurrentActiveCycleRequestSchema = z.object({
    params: z.object({
        userId: z.string().uuid('Invalid userId format. Must be a UUID.'), // 假设 userId 是 UUID
    }),
});
//# sourceMappingURL=subscription-cycle.schemas.js.map